<template lang="pug">
  b-container(fluid class="container-fluid-custom bg-greylight")
    b-row
      b-col(sm="3")
      b-col(sm="6" class="content-area-text")
        h2 About the AMIA-CIAT Project
        p(class="content-p") As one of the countries most vulnerable to climate risks, the Philippines has embarked on a major program initiative towards more resilient agri-fisheries sector. The Adaptation and Mitigation Initiative in Agriculture (AMIA) seeks to enable the Department of Agriculture (DA) to plan and implement strategies to support local communities in managing climate risks, from extreme weather events to long-term climatic shifts. Since 2014, AMIA has implemented activities to strengthen the DA’s capacity to mainstream climate change adaptation and mitigation strategies in its core functions of research and development, extension, and regulation. It is also designing complementary activities for building appropriate climate-responsive DA support services. The next big challenge is making climate-resilient agri-fisheries (CRA) an operational strategy through field-level action that directly involves, and impacts on the livelihoods of, farming communities. A critical prior step for AMIA to establish CRA communities would be:
        br
        ol
          li
            h3 Climate-Risk Vulnerability Assessment Project
            p(class="content-p") To assess climate-risk vulnerability in the proposed AMIA sites. This would ensure that AMIA investments are cost-effectively channeled to support its overall goals and outcomes. It also addresses the inherent spatial and temporal variabilities within and across sites.
          li
            h3 CRA Investment Prioritization Project
            p(class="content-p") To undertake program-wide intervention planning and resource targeting. Its key decision-makers, field implementation teams, and stakeholders would need to be equipped with readily accessible knowledge and user-friendly tools to support the rollout of CRA practices at scale.
          li
            h3 Monitoring and Evaluating Resilience Project
            p(class="content-p")  To achieve outcomes at scale by promoting the proven CRA practices and enhancing access to support services. An M&E system can help in decision-making, learning, and scaling of the intervention like CRA.
            br
            br
            br
        div(class="embed-responsive embed-responsive-16by9 video-youtube")
          h3 AMIA Video
          iframe(width="600" height="338" src="https://www.youtube.com/embed/II0csOe2sKg" frameborder="0" allowfullscreen)
      b-col(sm="3")
</template>

<script>
export default {
  name: 'Home'
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Home.vue